import React, { useEffect, useState } from 'react';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';

import { LoadingSpinner } from 'legacy-packages/ft-cb';
import makeCursor from 'legacy/src/utility/Cursor';

import transform from 'lodash/transform';
import TagSelectors from './TagSelectors';

const EditMetadataSimple = ({
  item,
  updateTags,
  subjectInfo,
  isLoading,
  tags,
  questionType,
  flattenHierarchy,
  twoLevelQBFilterFF,
  chosenEducationPeriodCode,
}) => {
  const [data, setData] = useState({
    tagCategories: null,
    defaultTags: null,
  });
  const [
    assessmentPurposeAndSourceMainTag,
    setAssessmentPurposeAndSourceMainTag,
  ] = useState(null);

  const [isAllLoading, setIsAllLoading] = useState(isLoading);

  const filterAssessmentPurposeAndSourceTags = (tagCategoriesData) => {
    if (
      tagCategoriesData &&
      tagCategoriesData.data &&
      tagCategoriesData.data.required_editable
    ) {
      const assessmentPurposeAndSourceCategory =
        tagCategoriesData.data.required_editable.find(
          (tagCategory) =>
            tagCategory.description === 'Assessment Purpose and Source',
        );

      if (
        assessmentPurposeAndSourceCategory &&
        assessmentPurposeAndSourceCategory.tags &&
        assessmentPurposeAndSourceCategory.tags.length
      ) {
        const assessmentPurposeAndSourceCategoryMainTag =
          assessmentPurposeAndSourceCategory.tags[0];
        const assessmentPurposeAndSourceCategoryTags =
          assessmentPurposeAndSourceCategoryMainTag.tags;

        if (
          assessmentPurposeAndSourceCategoryTags &&
          assessmentPurposeAndSourceCategoryTags.length
        ) {
          assessmentPurposeAndSourceCategoryTags.forEach((tag) => {
            const newTag = tag;
            newTag.tags = tag.tags.filter(
              (subTag) => subTag.description === 'My Question',
            );
          });
        }
        setAssessmentPurposeAndSourceMainTag(
          assessmentPurposeAndSourceCategoryMainTag,
        );
      }
    }
  };

  const selectChildrenTags = (selectedTags, mainTag) => {
    const allTags = selectedTags;

    if (
      mainTag &&
      Object.keys(selectedTags).includes(String(mainTag.category_id))
    ) {
      const mainTagIds = mainTag.tags.map((tag) => tag.id);

      const oldSelectedTags = tags[mainTag.category_id];
      const nextSelectedTags = selectedTags[mainTag.category_id];

      const selectedTagsDiff = oldSelectedTags
        ? nextSelectedTags.filter((tag) => !oldSelectedTags.includes(tag))
        : nextSelectedTags;

      selectedTagsDiff.forEach((newTag) => {
        if (mainTagIds.includes(newTag)) {
          const childrenTags = mainTag.tags
            .find((tag) => tag.id === newTag)
            .tags.map((tag) => tag.id);
          allTags[mainTag.category_id] = [
            ...allTags[mainTag.category_id],
            ...childrenTags,
          ];
        }
      });
    }

    return allTags;
  };

  useEffect(() => {
    async function loadDataTags() {
      const view =
        item.draft && item.draft.meta && item.draft.meta.original_item_info
          ? 'modified-item-editor'
          : 'created-item-editor';
      try {
        const tagCategoriesData = await axios.get(
          `${FYM_BACKEND_URL}/tagging/api/editor/subject/${subjectInfo.initId}/`,
          {
            params: {
              view,
              education_period: chosenEducationPeriodCode,
            },
          },
        );

        const defaultTagsData = await axios.get(
          `${FYM_BACKEND_URL}/tagging/api/editor/default/tags/${subjectInfo.initId}/`,
        );

        if (tagCategoriesData) {
          filterAssessmentPurposeAndSourceTags(tagCategoriesData);
          filterTagCategories(tagCategoriesData);
        }

        setData({
          tagCategories: tagCategoriesData.data,
          defaultTags: defaultTagsData.data,
        });
      } finally {
        setIsAllLoading(false);
      }
    }
    loadDataTags();
  }, []);

  const { tagCategories, defaultTags } = data;

  function filterTagCategories(tagCategoriesData) {
    if (questionType) {
      for (
        let index = 0;
        index < tagCategoriesData.data.required_editable.length;
        index++
      ) {
        const tagCategory = tagCategoriesData.data.required_editable[index];

        if (
          ['Question Type', 'Question Sub-Type'].includes(tagCategory.label)
        ) {
          const isFrq = (label) =>
            label !== 'MC' && label !== 'MCQ' && !label.startsWith('MCQ');

          if (questionType === 'FRQ') {
            tagCategory.tags = tagCategory.tags.filter((tag) =>
              isFrq(tag.label),
            );
          } else {
            tagCategory.tags = tagCategory.tags.filter(
              (tag) => !isFrq(tag.label),
            );
          }

          break;
        }
      }
    }
  }

  useEffect(() => {
    if (!isEmpty(tags) && tagCategories) {
      const requiredCategoryIds = tagCategories.required_editable.map(
        (cat) => cat.id,
      );
      const additionalCategoryIds = tagCategories.additional_editable.map(
        (cat) => cat.id,
      );

      // remove categories which are not needed for question publishing
      //. Practice and Practice & Skills, we care about only the last one
      // ideally `editQuestionQuery` should not return not needed categories, but only returned at
      // Request URL: https://apc-api.test:9091/fym/tagging/api/editor/subject/10133/?view=created-item-editor API

      const allCategoriesIds = requiredCategoryIds.concat(
        additionalCategoryIds,
      );

      const neededTags = transform(tags, (result, value, key) => {
        if (allCategoriesIds.includes(parseInt(key, 10))) {
          result[key] = value;
        }
        return result;
      });

      updateTags(neededTags, tagCategories);
    }
  }, [tagCategories]);

  if (isAllLoading) {
    return <LoadingSpinner />;
  }

  const cursor = makeCursor(tags, [], (t) =>
    updateTags(
      selectChildrenTags(t, assessmentPurposeAndSourceMainTag),
      tagCategories,
    ),
  );

  const existingTagsByItemType =
    item.draft && item.draft.meta && item.draft.meta.original_item_info
      ? tags
      : defaultTags.created;

  return (
    <TagSelectors
      editorView
      showAllTags
      tagCategories={tagCategories}
      existingTags={existingTagsByItemType}
      cursor={cursor}
      flattenHierarchy={flattenHierarchy}
      isCollapsible={twoLevelQBFilterFF}
      enableHierarchicalSelection={false}
    />
  );
};

EditMetadataSimple.defaultProps = {
  isLoading: true,
  item: {},
  tags: {},
  questionType: null,
};

const mapStateToProps = (state) => ({
  chosenEducationPeriodCode: state.userData.chosenEducationPeriodCode,
});
export default connect(mapStateToProps)(EditMetadataSimple);
